import styled from 'styled-components';

export const EmailVerifyPopWrap = styled.div(
    props => `
        width:100%;
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0,0,0,0.4);
        z-index:9;
    `
);

export const EmailVerifyPopContentWrap = styled.div(
    props => `
        width: 70rem;
        display: flex;
        background-color: #fff;
        border-radius: 0.8rem;
        flex-direction: column;
        padding: 3rem 2rem;
        height: 23rem;
    `
);

export const EmailVerifyPopHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin-bottom: 1rem;
        justify-content: flex-end;
        position: relative;
    `
);

export const PopBackBtn = styled.a(
    props => `
        font-size: 1.1rem;
        color: #0091ff;
        font-weight: 900;
        text-decoration: none;
        cursor: pointer;
        text-transform: uppercase;
    `
);

export const EmailVerifyBodyWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const EmailVerifyBodyHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const EmailVerifyMainText = styled.h2(
    props => `
        font-size: 2.8rem;
        color: #000000;
        font-weight: 900;
    `
);

export const EmailVerifyInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
    `
);

export const EmailVerifyInfoText = styled.p(
    props => `
        font-size: 1.5rem;
        color:#000000;
    `
);

export const EmailVerifiedTopWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-bottom: 3rem;
    `
);

export const EmailVerifiedImgWrap = styled.div(
    props => `
        width:6rem;
        height:6rem;
        display: flex;
        align-items: center;
        justify-content: center;
    `
);

export const EmailVerifiedInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const EmailVerifiedBottomWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: 1.5rem; 
        border-top: 0.5px solid rgba(0,0,0,0.2);
    `
);

export const PopupCloseBtn = styled.a(
    props =>`
        text-decoration: none;
        color: ${props.theme.colors.black.base};
        width: 2rem;
        height: 2rem;
        background-color: #9b9b9b;
        align-items: center;
        justify-content: center;
        display: flex;
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 0px;
    }
`);
